import FlexBox from '@/atomic-components/FlexBox';
import LencoButton from '@/atomic-components/LencoButton';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box, Button, Checkbox } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { pluralizeStringWithQuantity } from '@/utils/stringTransformations';
// import ArrowLeft from '@/assets/orders/arrow-left.svg';

export type TVasCustomizationConfirmationprops = {
	disableConfirmButton: boolean;
	allItemsSelected: boolean;
	onConfirm: () => void;
	selectAllItems: () => void;
	applyingVas: boolean;
	itemsCount: number;
};

const VasCustomizationConfirmation = (
	props: TVasCustomizationConfirmationprops
) => {
	function selectAllItems() {
		props.selectAllItems();
	}

	return (
		<Box sx={{ boxShadow: '0px 8px 16px rgba(34, 34, 34, 0.4)' }}>
			<Box
				sx={{
					p: '24px',
					width: '100%',
					backgroundColor: '#FFFFFF',
				}}
			>
				<FlexBox justifyContent='space-between'>
					<FlexBox justifyContent='start' mb='16px' onClick={selectAllItems}>
						<Checkbox
							sx={{ p: '0px', mr: '4px' }}
							checked={props.allItemsSelected}
						/>
						<LencoTypography
							sx={{ ...getStyle('P_Medium'), color: getColor('Gray -2') }}
							className='cursor-pointer'
						>
							Select All Products
						</LencoTypography>
					</FlexBox>
					<LencoTypography
						sx={{ ...getStyle('P_Regular'), color: getColor('Gray -2') }}
					>
						{pluralizeStringWithQuantity(props?.itemsCount, 'item')}
					</LencoTypography>
				</FlexBox>
				<LencoButton
					fullWidth
					// disabled={props.disableConfirmButton}
					color='primary'
					variant='contained'
					onClick={props.onConfirm}
					isLoading={props.applyingVas}
				>
					CONFIRM
				</LencoButton>
			</Box>
		</Box>
	);
};

export default VasCustomizationConfirmation;
